import { render, staticRenderFns } from "./onePayOrder.vue?vue&type=template&id=af31844c&scoped=true"
import script from "./onePayOrder.vue?vue&type=script&lang=js"
export * from "./onePayOrder.vue?vue&type=script&lang=js"
import style0 from "./onePayOrder.vue?vue&type=style&index=0&id=af31844c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af31844c",
  null
  
)

export default component.exports